exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3xqpmaFR7QqOnHKh-7vjoF{cursor:pointer;padding:2px 7px;border:1px solid;border-radius:3px;margin-right:8px;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"menuButton": "_3xqpmaFR7QqOnHKh-7vjoF"
};